import { create } from 'zustand';
import { BlockTimestamp, GasPrice, GasPriceUpdate } from '@/api/spec.ts';

interface ChainState {
  headBlock: number; // unused for now
  currentBlock: number;
  timestamp?: number;
  gasFees?: GasFees;
  // Sets current block id, timestamp, fees. Returns false if new block id is less than the current block (indicating
  // out-of-order updates)
  trySetLatest: (update: GasPriceUpdate) => boolean;
}

type GasFees = Omit<GasPrice, 'at'>;

export const useChainStore = create<ChainState>((set, get) => ({
  currentBlock: 0,
  headBlock: 0,
  trySetLatest: (update) => {
    if (update.d.at?.b != null) {
      if (get().currentBlock > update.d.at.b) {
        return false;
      }
      set((state) => {
        return {
          ...state,
          gasFees: update.d,
          headBlock: update.d.h,
          currentBlock: update.d.at.b,
          timestamp: update.d.at.t,
        };
      });
    }
    return true;
  },
}));
